import httpService from './httpService';

export default {
  query,
  queryFps,
  remove,
  save,
  downloadEmpSheet,
  saveEmpFp,
  getActiveEmps,
  getFpsByEmpId,
};

async function queryFps() {
  try {
    const fps = await httpService.get(`emp/fps`);
    _saveEmpFps(fps);
    return fps;
  } catch (err) {
    return _loadEmpFps();
  }
}
async function getActiveEmps() {
  try {
    const emps = await httpService.get(`emp/active`);
    _saveActiveEmps(emps);
    return emps;
  } catch (err) {
    return _loadActiveEmps();
  }
}
function query(filterBy) {
  let filters = [];
  for (let filterKey in filterBy) {
    const value = filterBy[filterKey];
    if (value !== null && value !== undefined)
      filters.push(filterKey + '=' + value);
  }
  let filterUrlParams = filters.length ? '?' + filters.join('&') : '';
  return httpService.get(`emp${filterUrlParams}`);
}

function remove(empId) {
  return httpService.delete(`emp/${empId}`);
}
function _add(emp) {
  return httpService.post(`emp`, emp);
}
function save(emp) {
  return emp._id ? _update(emp) : _add(emp);
}
async function getFpsByEmpId(empId) {
  try {
    const fps = await httpService.get(`emp/fps/${empId}`);
    return fps;
  } catch (err) {
    return [];
  }
}
async function saveEmpFp(empId, data, variant) {
  const res = await httpService.put(`emp/fp`, { empId, data, variant });
  return res.data || { empId, data, variant };
}
function _update(emp) {
  return httpService.put(`emp/${emp._id}`, emp);
}
function downloadEmpSheet() {
  return httpService.customRequest('GET', `emp/download`, null, {
    responseType: 'arraybuffer',
  });
}
function _saveActiveEmps(emps) {
  localStorage.setItem('activeEmps', JSON.stringify(emps));
}
function _loadActiveEmps() {
  return JSON.parse(localStorage.getItem('activeEmps') || '[]');
}
function _saveEmpFps(empFps) {
  localStorage.setItem('empFps', JSON.stringify(empFps));
}
function _loadEmpFps() {
  return JSON.parse(localStorage.getItem('empFps') || '[]');
}
